import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { fetchMainPageInfo } from 'modules/main/store/main-page/actions';
import type { MainPageSliceState } from './main-page-store';
import { TEAM_DEFAULT_LOGO, USER_DEFAULT_AVATAR } from 'shared/constants/links';

type ReducerBuilder = ActionReducerMapBuilder<MainPageSliceState>;

function nameConnotation(user?: { name?: string; middleName?: string }) {
  const { name, middleName } = user ?? {};
  if (middleName) {
    return `${middleName} ${name ? name[0].toUpperCase() + '.' : ''}`;
  }
}

export function createFetchChampionshipsReducer(builder: ReducerBuilder) {
  builder.addCase(fetchMainPageInfo.pending, (state) => {
    state.status.loading = true;
    state.status.loaded = false;
    state.status.error = null;
  });

  builder.addCase(fetchMainPageInfo.fulfilled, (state, action) => {
    state.status.loading = false;
    state.status.loaded = true;
    state.status.error = null;

    state.tournamentId = action.meta.arg.tournamentId;
    const payload = action.payload;

    state.totalChampionships = payload.championships ?? 0;
    state.championships = {
      ended: payload.finishedChampionships ?? 0,
      preparing: payload.upcomingChampionships ?? 0,
      stared: payload.activeChampionships ?? 0,
    };

    state.teams = {
      total: payload.teams ?? 0,
      declared: payload.acceptedApplicationsTeams ?? 0,
      popular:
        payload.topTeams?.map((team) => ({
          id: team.team?.id ?? 0,
          name: team.team?.name ?? 'Неизвестно',
          image: team.team?.emblem?.externalUrl ?? TEAM_DEFAULT_LOGO,
        })) ?? [],
    };

    state.players = {
      total: payload.players ?? 0,
      declared: payload.acceptedApplicationsPlayers ?? 0,
      bestScorers:
        payload.topShooters?.map((shooter) => ({
          id: shooter.user?.id ?? 0,
          name: (shooter.user?.surname ?? '') + ' ' + (shooter.user?.name ?? ''),
          goals: shooter.goals ?? 0,
          image: shooter.user?.photo?.externalUrl ?? USER_DEFAULT_AVATAR,
        })) ?? [],
    };
  });

  builder.addCase(fetchMainPageInfo.rejected, (state, action) => {
    state.status.loading = true;
    state.status.loaded = false;
    state.status.error = action.error.message ?? null;
  });
}
